import { PartnersService } from 'data/services/partners';
import { PartnersServiceInterface } from 'domain/services';
import { makeRemoteGetAllPartners } from 'main/factories/usecases/partners/get-all-partners';
import { makeRemoteCreatePartner } from 'main/factories/usecases/partners/create-partner';
import { makeRemoteUpdatePartner } from 'main/factories/usecases/partners/update-partner';
import { makeRemoteGetAllPartnerRequests } from 'main/factories/usecases/partners/get-all-partner-requests';
import { makeRemoteCreatePartnerRequest } from 'main/factories/usecases/partners/create-partner-request';
import { makeRemoteUpdatePartnerRequest } from 'main/factories/usecases/partners/update-partner-request';
import { makeRemoteTogglePartnerRequest } from 'main/factories/usecases/partners/toggle-partner-request';
import { makeRemoteGeneratePartnerRequestKey } from 'main/factories/usecases/partners/generate-partner-request-key';
import { makeRemoteGetKeyPreview } from 'main/factories/usecases/partners/get-key-preview';

export const makePartnersService = (): PartnersServiceInterface => {
  return new PartnersService({
    getAllPartners: makeRemoteGetAllPartners(),
    createPartner: makeRemoteCreatePartner(),
    updatePartner: makeRemoteUpdatePartner(),
    getAllPartnerRequests: makeRemoteGetAllPartnerRequests(),
    createPartnerRequest: makeRemoteCreatePartnerRequest(),
    updatePartnerRequest: makeRemoteUpdatePartnerRequest(),
    togglePartnerRequest: makeRemoteTogglePartnerRequest(),
    generatePartnerRequestKey: makeRemoteGeneratePartnerRequestKey(),
    getKeyPreview: makeRemoteGetKeyPreview(),
  });
};
